/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 16/9/2020
 */
import mergeProps from "@/router/utils/mergeProps";
let EmptyRouterView = () => import(/* webpackChunkName: "localTools" */  "@/core/components/EmptyRouterView.vue");
import redirectByName from "@/router/utils/redirectByName.js";
let AttachmentQuizMain = () => import(/* webpackChunkName: "localTools" */  "@/core/modules/coach/Resources/CoachingTools/AttachmentQuiz/AttachmentQuizMain.vue");
import formQuestionsAnswersRoutes from "@/router/resources/formQuestionsAnswersRoutesFn.js";
let FormMain = () => import(/* webpackChunkName: "localTools" */  "@/core/modules/coach/Resources/Forms/FormMain.vue");

let WheelOfLifeMainTabs = () => import(/* webpackChunkName: "localTools" */ '@/core/modules/coach/Resources/CoachingTools/WheelOfLife/WheelOfLifeMainTabs.vue')
let AddPractitionerToolPage = () => import(/* webpackChunkName: "GenericTools" */ '@/core/modules/coach/Resources/CoachingTools/GenericTools/AddPractitionerToolPage.vue')
let GenericToolMainTabs = () => import(/* webpackChunkName: "GenericTools" */ '@/core/modules/coach/Resources/CoachingTools/GenericTools/GenericToolMainTabs.vue')
let ToolInstanceDetailsPage = () => import(/* webpackChunkName: "ToolInstanceDetails" */ '@/core/modules/coach/Resources/CoachingTools/ToolInstanceDetailsPage.vue')
import {ToolTypeEnum} from "@shared/GenericTools/ToolTypeEnum.js";

export default [
	{
		path: 'tools/instance/:ownerId/:toolType/:toolInstanceId/:activeTab(settings|results)',
		name: 'ToolInstanceDetailsRoute',
		component: ToolInstanceDetailsPage,
		props: mergeProps,
	},
	{
		path: 'tools/wheeloflife/templates/:parentWheelId/results',
		name: 'WheelToolResultsRoute',
		component: ToolInstanceDetailsPage,
		props: route => ({...mergeProps(route), toolType: ToolTypeEnum.WHEEL_OF_LIFE, toolInstanceId: route.params.parentWheelId, activeTab: 'results'}),
	},
	{
		path: 'tools/:toolType/templates/:toolInstanceId/results',
		name: 'GenericToolResultsRoute',
		component: ToolInstanceDetailsPage,
		props: route => ({...mergeProps(route), activeTab: 'results'}),
	},
	{
		path: 'tools/wheeloflife',
		redirect: redirectByName('WheelOfLifeTabsRoute', {activeTab: 'templates'}),
		name: 'WheelOfLifeMainRoute',
		component: EmptyRouterView,
		props: mergeProps,
		children: [
			{
				path: ':activeTab',
				name: 'WheelOfLifeTabsRoute',
				component: WheelOfLifeMainTabs,
			},
			{
				path: 'results/:wheelAnswerId',
				name: 'ResourcesWheelDetailsAnswers',
				component: () => import('@/core/modules/coach/Resources/CoachingTools/WheelOfLife/WheelOfLifeAssessmentResultPage.vue'),
				// Resolve the linked portal in the page before checking its result access.
				meta: {allowExpiredSubscription: true},
				props: route => ({
					coachId: route.query.ownerId,
					wheelId: route.params.wheelAnswerId,
					teamMemberId: route.query.teamMemberId,
					requiresPractitionerAccess: true,
				}),
			},

		]
	},

	{
		path: 'tools/attachmentquiz',
		name: 'AttachmentQuizMainRoute',
		redirect: redirectByName('AttachmentQuizFormRoute'),
		component: AttachmentQuizMain,
		props: mergeProps,
		...formQuestionsAnswersRoutes(FormMain, 'AttachmentQuizFormRoute', 'ResourcesToolsRouteName'),
	},
	{
		path: 'tools/add',
		name: 'AddPractitionerToolRoute',
		component: AddPractitionerToolPage,
		props: mergeProps,
	},
	{
		path: 'tools/:toolType',
		redirect: redirectByName('GenericToolTabsRoute', {activeTab: 'templates'}),
		name: 'GenericToolMainRoute',
		component: EmptyRouterView,
		props: mergeProps,
		children: [
			{
				path: ':activeTab',
				name: 'GenericToolTabsRoute',
				component: GenericToolMainTabs,
				props: mergeProps,
			},
		],
	},
	{
		path: 'tools/:toolType/templates/:toolInstanceId/edit',
		name: 'GenericToolTemplateEditRoute',
		component: ToolInstanceDetailsPage,
		props: route => ({...mergeProps(route), activeTab: 'settings'}),
	},


]
